/**
 * CollectionCard Component
 */

import { getImagePathForSize } from '../../../../utils/image';
import { linkWithCurrentQueryString } from '../../../../utils/router';

import { Link, withRouter, WithRouter } from 'found';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import './styles.scss';

import ImageLoaded from '../../../../containers/ImageLoaded';
import CardPlayButton from '../../../atoms/buttons/CardPlayButton';
import { LogoBopper } from '../../../atoms/images/Icon';
import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';
import { CollectionPagePath } from '../../../pages/Collection';

interface IOwnProps {
  image: IResponsiveImage;
  isPlaying?: boolean;
  size?: 'medium' | 'large' | 'vertical';
  slug: string;
  subtitle: string;
  title: string;
  topic?: string;
}

interface IOwnState {
  isHover: boolean;
  isPlaying: boolean;
}

type CollectionCardProps = IOwnProps & WithRouter;

const classes = new BEM('collection-card');

class CollectionCard extends React.Component<CollectionCardProps, IOwnState> {
  static defaultProps: Partial<CollectionCardProps> = {
    size: 'large',
    topic: 'Collection',
  };

  constructor(props: CollectionCardProps) {
    super(props);

    this.state = {
      isHover: false,
      isPlaying: !!props.isPlaying,
    };
  }

  componentWillReceiveProps({ isPlaying }: CollectionCardProps) {
    if (isPlaying !== this.props.isPlaying) {
      this.setState({
        isPlaying: !!isPlaying,
      });
    }
  }

  render() {
    const {
      image,
      size,
      subtitle,
      title,
      topic,
    } = this.props;

    const {
      isHover,
    } = this.state;

    const classModifiers = {
      hover: isHover,
      [size!]: true,
    };

    const imageSrc = getImagePathForSize(image, 'small');
    const blurredImageSrc = image.blur && image.blur.length ? image.blur[0].path : imageSrc;

    return (
      <ImageLoaded background=".collection-card__image">
        {({ imageLoaded }) => {
          return (
            <Link
              onMouseEnter={this.onMouseEnter}
              onMouseLeave={this.onMouseLeave}
              {...classes('', { ...classModifiers, loading: !!!imageLoaded })}
              to={linkWithCurrentQueryString(CollectionPagePath(this.props.slug))}
            >
              <div {...classes('wrapper') }>
                <div
                  style={{ backgroundImage: `url(${imageSrc})` }}
                  {...classes('image') }
                />
                {/*<div {...classes('image-mask') } />*/}
                <div {...classes('title-wrapper') }>
                  <Span size="small">{subtitle}</Span>
                  <Heading
                    is="h3"
                    text={title}
                    {...classes('title') }
                  />
                </div>
                <div {...classes('topic-wrapper') }>
                  <LogoBopper />
                  <Span size="small" {...classes('topic') }>{topic}</Span>
                </div>
                <CardPlayButton blurredImage={blurredImageSrc} />
              </div>
            </Link>
          );
        }}
      </ImageLoaded>
    );
  }

  onMouseEnter = () => this.toggleHover(true);
  onMouseLeave = () => this.toggleHover(false);

  toggleHover = (toggle?: boolean) => {
    this.setState((prevState) => ({
      isHover: toggle || !prevState.isHover,
    }));
  }
}

const CollectionCardWithRouter = withRouter<IOwnProps>(CollectionCard);

export default CollectionCardWithRouter;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/media/CollectionCard/index.tsx